import * as Yup from 'yup';

function momentToDate (value, originalValue) {
    return originalValue && originalValue.clone().toDate();
}

const AgentLogTimestampFilter = Yup.object().shape({
    endTimestamp: Yup.date()
        .transform(momentToDate)
        .nullable()
        .min(
            Yup.ref('startTimestamp'),
            'End date must be after the start date.'
        ),
    startTimestamp: Yup.date()
        .transform(momentToDate)
        .nullable()
});

export default AgentLogTimestampFilter;
